<script>
import formatDate from '@utils/format-date'
import formMixin from './mixins/form'
import { authComputed } from '@store/helpers'
import { genderOptions } from '@utils/zerone-options'
import { messageSuccess, messageInfo } from '@utils/message'
import { eventIsDealerOnly } from '@utils/zerone-event'
const DEFAULT_SUBMIT_DATA = {
  couponCode: '',
  couponInfo: {},

  isSameMemberInfo: false,
  fullName: '',
  gender: '',
  phoneCode: '+886',
  phoneNumber: '',
  email: '',
  note: '',

  isAgreePrivacy: false,
  isAgreeProtection: false,
}

export default {
  components: {
    CountryCodePicker: () => import('@components/Input/CountryCodePicker'),
    DialogProtection: () => import('@components/Dialog/Protection'),
    DialogPrivacy: () => import('@components/Dialog/Privacy'),
    DialogCoupon: () => import('@components/Dialog/Coupon'),
  },
  mixins: [formMixin],
  props: {
    value: {
      type: Object,
      default: () => {
        return { ...DEFAULT_SUBMIT_DATA }
      },
    },
    cartItem: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isDialogPrivacyVisible: false,
      isDialogProtectionVisible: false,
      isDialogCouponVisible: false,
      genderOptions: genderOptions(),
    }
  },
  computed: {
    ...authComputed,
    isDealerOnly() {
      return eventIsDealerOnly({ ...this.cartItem })
    },
    isWritePhoneNumber() {
      const phoneRegExp = new RegExp(/^09/)
      const numberRegExp = new RegExp(/^[0-9]*$/)
      if (phoneRegExp.test(this.FormMixSubmitData.phoneNumber) && numberRegExp.test(this.FormMixSubmitData.phoneNumber) && String(this.FormMixSubmitData.phoneNumber).length === 10) {
        return true
      } else {
        return false
      }
    },
  },
  methods: {
    formatDate,
    onSubmit() {
      this.$emit('submit')
    },
    onPrev() {
      this.$emit('prev')
    },
    onChangeIsSameMemberInfo(value) {
      if (value) {
        this.FormMixSubmitData.fullName = this.currentMember.name || DEFAULT_SUBMIT_DATA.fullName
        // this.FormMixSubmitData.gender = 'male';
        this.FormMixSubmitData.phoneCode = this.currentMember.mobilePhoneCode || DEFAULT_SUBMIT_DATA.phoneCode
        this.FormMixSubmitData.phoneNumber = this.currentMember.mobilePhone || DEFAULT_SUBMIT_DATA.phoneNumber
        this.FormMixSubmitData.email = this.currentMember.company.email || DEFAULT_SUBMIT_DATA.email
      }
    },
    openDialogCoupon() {
      this.isDialogCouponVisible = true
    },
    tryToCheckCoupon() {
      this.$store
        .dispatch('coupon/checkCoupon', {
          code: this.FormMixSubmitData.couponCode,
          eventAlias: this.cartItem.alias,
        })
        .then((response) => {
          this.FormMixSubmitData.couponInfo = response.items

          messageSuccess({
            title: '已使用',
            content: `${this.FormMixSubmitData.couponInfo.title}:${this.FormMixSubmitData.couponInfo.code}`,
          })
        })
    },
    onChangeCouponInfo(couponInfo) {
      this.FormMixSubmitData.couponInfo = couponInfo
      this.FormMixSubmitData.couponCode = couponInfo.code
      this.FormMixSubmitData.isUsePrepaid = false

      messageSuccess({
        title: '已使用',
        content: `${this.FormMixSubmitData.couponInfo.title}:${this.FormMixSubmitData.couponInfo.code}`,
      })
    },
    onResetCoupon() {
      messageInfo({
        title: '已清除',
        content: `${this.FormMixSubmitData.couponInfo.title}:${this.FormMixSubmitData.couponInfo.code}`,
      })

      this.FormMixSubmitData.couponInfo = {}
      this.FormMixSubmitData.couponCode = ''
    },
  },
}
</script>
<template>
  <div :class="$style.formApplyStep2">
    <ValidationObserver v-slot="{ invalid, handleSubmit }">
      <el-form ref="form" :model="FormMixSubmitData" class="isStyleBase" label-position="top" @submit.prevent.native="handleSubmit(onSubmit)">
        <div class="globalWhiteBox mb-5">
          <div class="row">
            <div class="col-12 d-flex mb-4">
              <p class="color-gray-7 font-medium mr-3 mb-0">填寫報名資訊</p>
              <el-checkbox v-model="FormMixSubmitData.isSameMemberInfo" style="top: 3px" @change="onChangeIsSameMemberInfo"> 參與人同會員資料 </el-checkbox>
            </div>
            <!-- 姓名 -->
            <div class="col-12">
              <ValidationProvider v-slot="{ errors }" rules="require" name="姓名">
                <el-form-item prop="name" :error="errors[0]" label="參與人姓名" class="isRequire">
                  <el-input ref="name" v-model="FormMixSubmitData.fullName" placeholder="" autocomplete="text" inputmode="text"> </el-input>
                </el-form-item>
              </ValidationProvider>
            </div>
            <!-- 手機號碼 -->
            <div class="col-12">
              <ValidationProvider v-slot="{ errors }" :rules="FormMixSubmitData.phoneCode === '+886' ? 'require|phone' : 'require'" name="電話">
                <el-form-item :error="errors[0]" prop="phoneNumber" label="參與人手機" class="isRequire">
                  <el-input ref="phoneNumber" v-model="FormMixSubmitData.phoneNumber" placeholder="" autocomplete="tel" inputmode="tel">
                    <CountryCodePicker slot="prepend" v-model="FormMixSubmitData.phoneCode" />
                  </el-input>
                </el-form-item>
              </ValidationProvider>
            </div>
            <!-- 個人電子郵件 -->
            <div :class="`col-md-12`">
              <ValidationProvider v-slot="{ errors }" rules="require|email" name="參與人電子郵件" :debounce="500">
                <el-form-item label="參與人電子郵件" :error="errors[0]" prop="email" class="isRequire">
                  <BaseEmail v-model="FormMixSubmitData.email" />
                </el-form-item>
              </ValidationProvider>
            </div>
            <!-- 公司名稱 -->
            <div v-if="isWritePhoneNumber && FormMixSubmitData.phoneNumber !== currentMember.mobilePhone" :class="`col-md-12`">
              <ValidationProvider v-slot="{ errors }" rules="require" name="公司名稱">
                <el-form-item label="公司名稱(參與人手機與登入者手機不同需填寫)" :error="errors[0]" prop="companyName" class="isRequire">
                  <el-input ref="companyName" v-model="FormMixSubmitData.company.name" placeholder="" autocomplete="text" inputmode="text"> </el-input>
                </el-form-item>
              </ValidationProvider>
            </div>
            <!-- 公司統編 -->
            <div v-if="isWritePhoneNumber && FormMixSubmitData.phoneNumber !== currentMember.mobilePhone && isDealerOnly" :class="`col-md-12`">
              <ValidationProvider v-slot="{ errors }" rules="require|companyid" name="公司統編">
                <el-form-item label="公司統編(參與人電話與登入者電話不同需填寫)" :error="errors[0]" prop="companyName" class="isRequire">
                  <el-input ref="companyVat" v-model="FormMixSubmitData.company.vat" placeholder="" autocomplete="text" inputmode="text"> </el-input>
                </el-form-item>
              </ValidationProvider>
            </div>
            <!-- 備註 -->
            <div class="col-12">
              <el-form-item prop="other" label="其他備註" class="mb-1">
                <el-input v-model="FormMixSubmitData.note" type="textarea" :autosize="{ minRows: 6, maxRows: 6 }" placeholder=""> </el-input>
              </el-form-item>
            </div>
            <!-- 同意按鈕 -->
            <div class="col-12 mt-2">
              <el-checkbox v-model="FormMixSubmitData.isAgreePrivacy" style="top: 0"> 我已閱讀並同意 </el-checkbox>
              <BaseButton class="isStylePrimary isTextUnderline formApplyStep2__dialogBtn" @click="isDialogPrivacyVisible = true"> 隱私權聲明 </BaseButton>
            </div>
            <div class="col-12 mt-2">
              <el-checkbox v-model="FormMixSubmitData.isAgreeProtection" style="top: 0"> 我已閱讀並同意 </el-checkbox>
              <BaseButton class="isStylePrimary isTextUnderline formApplyStep2__dialogBtn" @click="isDialogProtectionVisible = true"> 零壹科技保有您的個人資訊 </BaseButton>
            </div>
            <div class="col-12">
              <hr />
            </div>
            <div v-if="cartItem.requireCoupon" class="col-12">
              <p class="color-gray-7 font-medium">上課卷代碼</p>
              <el-form-item label="選取上課卷" class="isHiddenLabel mb-0">
                <div class="d-flex">
                  <div style="flex: 1">
                    <el-input ref="coupon" v-model="FormMixSubmitData.couponCode" :disabled="!!FormMixSubmitData.couponInfo.code" placeholder="請輸入上課卷代碼" inputmode="text"> </el-input>
                    <BaseButton class="isStylePrimary isTextUnderline mt-3 formApplyStep2__checkCouponBtn" :disabled="$isLoading('checkCoupon')" @click="openDialogCoupon">
                      查看可使用的上課券
                    </BaseButton>
                  </div>
                  <div style="flex-shrink: 0">
                    <BaseButton v-if="!FormMixSubmitData.couponInfo.code" class="isStylePrimary isSmall formApplyStep2__couponBtn" :disabled="!FormMixSubmitData.couponCode" @click="tryToCheckCoupon">
                      使用上課券
                    </BaseButton>
                    <BaseButton v-else class="isStylePrimary isOutline isSmall formApplyStep2__couponBtn" @click="onResetCoupon"> 清除 </BaseButton>
                  </div>
                </div>
              </el-form-item>
            </div>
          </div>
        </div>
        <BaseButton type="submit" :loading="loading" class="isStylePrimary isRadius isFull" :disabled="invalid || !FormMixSubmitData.isAgreePrivacy || !FormMixSubmitData.isAgreeProtection">
          確認報名
        </BaseButton>
        <BaseButton class="isStylePrimary isOutline2 mt-4 isRadius isFull" @click="onPrev"> 回上一步 </BaseButton>
        <BaseButton class="isStylePrimary isOutline2 mt-4 isRadius isFull" :to="{ name: 'brand-event-item' }"> 回活動介紹頁 </BaseButton>
      </el-form>
    </ValidationObserver>
    <DialogCoupon :visible.sync="isDialogCouponVisible" :coupon-info="FormMixSubmitData.couponInfo" :cart-item="cartItem" @change="onChangeCouponInfo" />
    <DialogPrivacy :visible.sync="isDialogPrivacyVisible" />
    <DialogProtection :visible.sync="isDialogProtectionVisible" />
  </div>
</template>
<style lang="scss" module>
// stylelint-disable selector-class-pattern
.formApplyStep2 {
  :global {
    .formApplyStep2 {
      @include unstyled;
      &__dialogBtn {
        // margin-left: -$container-gap;
        @include max-md {
          font-size: 0.875rem;
        }
        @include max-sm {
          font-size: 0.75rem;
          margin-left: -12px;
        }
      }
      &__couponBtn {
        @include max-md {
          padding: 1.16rem 1.5rem;
        }
      }
      &__checkCouponBtn {
        @include max-md {
          font-size: 0.875rem;
        }
        @include max-sm {
          font-size: 0.75rem;
        }
      }
    }
  }
}
</style>
